import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { ORDER_DETAIL_KEY } from "@/features/pathpick/features/order-history/features/detail/constants";
import useAutoCancelCountdown from "@/features/pathpick/features/order-history/features/detail/hooks/useAutoCancelCountdown";

interface Props {
  dueAt: string;
}

// 입금 기한까지 남은 시간 안내. 기한이 지나도 캐시된 주문 상태는 그대로일 수 있어
// 음수 대신 만료 문구를 노출한다.
function PathPickOrderDetailAutoCancelBox({ dueAt }: Props) {
  const { t } = useI18nHelper();
  const remaining = useAutoCancelCountdown(dueAt);

  if (!remaining) return null;

  return (
    <Flex
      gap={"8px"}
      padding={"12px 16px"}
      borderRadius={"8px"}
      background={"#FFFBEB"}
    >
      <CustomIcon src={"clock"} width={16} height={16} color={"#B27700"} />
      <Flex flexDirection={"column"} gap={"4px"}>
        <Text textStyle={"body-sm-bold"} color={"#1D1D1B"}>
          {remaining.isExpired
            ? t(`${ORDER_DETAIL_KEY}payment_auto_cancel_expired`)
            : t(`${ORDER_DETAIL_KEY}payment_auto_cancel`, {
                hours: remaining.hours,
                minutes: remaining.minutes,
              })}
        </Text>
        <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
          {t(`${ORDER_DETAIL_KEY}payment_auto_cancel_desc1`)}
        </Text>
        <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
          {t(`${ORDER_DETAIL_KEY}payment_auto_cancel_desc2`)}
        </Text>
      </Flex>
    </Flex>
  );
}

export default PathPickOrderDetailAutoCancelBox;
